import { environment } from '@env/environment'
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core'
import { Room, joinRoom } from 'trystero'
import { CommonModule } from '@angular/common'
import { PlayerService } from '../../../../@shared/services/player.service'
import { ErrorAlertComponent, SuccessAlertComponent } from '@shared/components'
import { PlayerBetDto, SeatDto } from '@core/dtos'
import { Subscription } from 'rxjs'
import { ModeEnum } from '@core/enums'
import { WebSocketService } from '@core/services'
import { GameHttp } from '@core/https'
import { BetTypeEnum } from '@shared/enums'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'

@Component({
  selector: 'app-live-video',
  standalone: true,
  imports: [CommonModule, SuccessAlertComponent, ErrorAlertComponent],
  templateUrl: './live-video.component.html',
  styleUrl: './live-video.component.sass',
})
export class LiveVideoComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('inbetween_video') inbetweenVideo: ElementRef
  @ViewChild('playerVideoContainer') playerVideoContainer: ElementRef

  @Input() dealerId: string

  private readonly _subscription = new Subscription()

  private inbetweenStream: MediaStream

  streamActivated = false
  dealerPeerId: string
  currentSeat?: SeatDto
  lastStreamValue: boolean
  mode: ModeEnum
  modeType = ModeEnum

  showWinnerMessage = false
  showLoserMessage = false

  get room(): Room {
    return this._playerService.rtcRoom
  }
  get playerBetResult(): PlayerBetDto | undefined {
    return this._playerService.playerBetResult
  }

  get currentSeatNo(): number {
    return this._playerService.currentSeat?.seatNo || 0
  }

  get clientHeight(): number {
    return this.playerVideoContainer?.nativeElement.clientHeight || 0
  }
  get clientWidth(): number {
    return this.playerVideoContainer?.nativeElement.clientWidth || 0
  }

  constructor(
    public _playerService: PlayerService,
    private _webSocketService: WebSocketService,
    private _gameHttp: GameHttp,
  ) {}

  ngOnInit(): void {
    this._subscription.add(
      this._playerService.currentSeat$.subscribe((i) => {
        this.currentSeat = i
      }),
    )

    this._subscription.add(
      this._gameHttp.getCurrentConfig(this.dealerId).subscribe((i) => {
        this.mode = i.mode
      }),
    )

    this._subscription.add(
      this._playerService.playerBetResult$.subscribe((result) => {
        this.showWinnerMessage = result?.isWinner === true
        this.showLoserMessage = result?.isWinner !== true
      }),
    )

    this._webSocketService.listenToMode(this.dealerId, ({ mode }) => {
      this.mode = mode

      // if (mode === ModeEnum.Paused) {
      //   this._playerService.rtcRoom.leave()
      // } else {
      //   this.startStreaming()
      // }
    })
  }

  async ngAfterViewInit(): Promise<void> {
    // this.startStreaming()
  }

  closeMessage() {
    this.showWinnerMessage = false
    this.showLoserMessage = false
  }

  async startStreaming(): Promise<void> {
    const config = { appId: environment.webRtc.appId }
    const roomId = this.dealerId || ''

    this._playerService.rtcRoom = joinRoom(config, roomId)

    this._playerService.rtcRoom.onPeerStream((stream, peerId) => {
      this.inbetweenVideo.nativeElement.srcObject = stream
      this.streamActivated = true
      this.dealerPeerId = peerId
    })

    this._playerService.rtcRoom.onPeerLeave(async (peerId) => {
      if (peerId !== this.dealerPeerId) {
        this.streamActivated = false
      }
    })
  }

  pauseLocalVideo(): void {
    this.inbetweenStream.getTracks().forEach((track) => {
      track.enabled = false
    })

    this.inbetweenVideo.nativeElement.srcObject = undefined
  }

  setDealerById(dealerId: string): void {
    this._playerService.setActiveDealerById(dealerId)
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe()
    this._webSocketService.closeAllListeners()
  }
}
